import { roundToPlaces } from "../../utils/roundToPlaces.js";
import type { Currency } from "../Currency.js";
import type { ExchangeRate } from "../ExchangeRatesSetting.js";
import { resolveExchangeRate } from "./resolveExchangeRate.js";

export function convertPriceInCzkToCurrency(
	priceInCzk: number,
	targetCurrency: Currency,
	exchangeRates: ExchangeRate[],
): number {
	return roundToPlaces(priceInCzk / resolveExchangeRate(targetCurrency, exchangeRates), 2);
}
